import { render, staticRenderFns } from "./VeJwBjggList.vue?vue&type=template&id=7c843cac&scoped=true"
import script from "./VeJwBjggList.vue?vue&type=script&lang=js"
export * from "./VeJwBjggList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c843cac",
  null
  
)

export default component.exports